export const capitalize = (str: string) => {
  if (str.length < 2) return str;

  const first = str[0].toUpperCase();
  const rest = str.slice(1);

  return first + rest;
};
